const unlinkWarning = (vue,h) => {
    return new Promise(resolve => {
        const messageVNode = h('div', { class: 'text-center p-3' }, [
            // 1. 경고 아이콘
            h('b-icon-exclamation-triangle-fill', {
                props: { variant: 'warning', fontScale: '3' },
                class: 'mb-2'
            }),
            
            // 3. 상세 설명 (배경으로 구분하여 가독성 향상)
            h('div', { class: 'bg-light p-3 rounded text-left' }, [
                h('p', { class: 'mb-2 ', style: {fontWeight: '500'} }, [
                    h('b-icon-dot', { props: { fontScale: '1.2' } }),
                    ` ${vue.$t('선택한 답안이 아닌 하위 질문의 첨부파일은 모두 링크 해제됩니다.')}`,
                ]),
                h('p', { class: 'mb-0 text-danger', style: {fontWeight: '500'} }, [
                    h('b-icon-dot', { props: { fontScale: '1.2' } }),
                    h('strong', ` ${vue.$t('또한 마지막으로 링크 해제된 첨부파일은 삭제되며 복구할 수 없습니다.')}`)
                ])
            ]),
            
            // 2. 메인 경고 메시지
            h('h4', { class: 'mb-4' }, `${vue.$t('정말로 계속하시겠습니까?')}`),
        ]);
        
        vue.$bvModal.msgBoxConfirm(messageVNode, {
            title: vue.$t('첨부파일 링크 해제'),
            okVariant: 'danger',
            okTitle: vue.$t('확인'),
            cancelTitle: vue.$t('취소'),
            hideHeaderClose: false,
            centered: true,
            size: 'md', // 필요시 'lg', 'sm' 등 조정
            headerBgVariant: 'dark',
            headerTextVariant: 'light',
            noCloseOnBackdrop: true,
            bodyClass: 'pb-0'
        })
            .then((value)=>{
                resolve(value)
            })
    })
    
}
export {unlinkWarning}
